var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"menu"},_vm._l((_vm.navigation),function(item){return _c('Cta',{key:item.id,attrs:{"data":{
      url: item.url,
      title: item.content,
      target: item.target,
    },"theme":"menu"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }